import { faExternalLink, faUser } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useEffect, useState } from "react";
import { Form, InputGroup } from "react-bootstrap";
import { InputText } from "../../../../../../components/Inputs";
import { InputRadios } from "../../../../../../components/Inputs/InputRadios";
import { InputSelect } from "../../../../../../components/Inputs/InputSelect";
import { FilterPersona } from "../../../../../../components/Modals/ModalFilters/FilterPersona";
import { useLang } from "../../../../../../language";
import { PersonaEntidadesServices } from "../../../../../administracion/pages/Entidades/Entidad/SeccionPersonas/services/datosprofesionales.persona.services";
import { AparatosServices } from "../../Aparatos/controllers/services/aparatos.service";

export const SeccionDatosGenerales = ({ formInscripcion, handleInputInscripcion, handleFormInscripcion,
    valuesValidationPersona, valuesValidationEntidad, isGratuito, idpedido }: any) => {

    const Lang = useLang()

    // ---------- Filtro de personas

    const [showModal_FiltroPersonas, setShowModal_FiltroPersonas] = useState({
        value: false,
        payload: {}
    });

    const handleCloseModal_FiltroPersonas = () => setShowModal_FiltroPersonas({
        value: false,
        payload: {}
    });

    const handleShowModal_FiltroPersonas = (payload: any) => setShowModal_FiltroPersonas({
        value: true,
        payload
    });

    const [filterPersona, setFilterPersona] = useState({
        id: formInscripcion.idpersona || '',
        nombre: formInscripcion.nombre_completo || '',
    })

    useEffect(() => {

        handleFormInscripcion({
            ...formInscripcion,
            idpersona: filterPersona.id,
            nombre_completo: filterPersona.nombre
        })

    }, [filterPersona])

    useEffect(() => {
        if (!formInscripcion.idpersona) {
            setFilterPersona({
                id: '',
                nombre: ''
            })
        }
    }, [formInscripcion.idpersona])

    const [fetchPersonaEntidadGET, fetchPersonaEntidadGETData, resetfetchPersonaEntidadGET] = PersonaEntidadesServices.GET()

    useEffect(() => {

        if (formInscripcion.idpersona) {

            fetchPersonaEntidadGET({
                params: {
                    idpersona: formInscripcion.idpersona,
                    statuspersonaentidad: 'activos'
                }
            })
        } else {

            resetfetchPersonaEntidadGET()
        }

    }, [formInscripcion.idpersona]);

    useEffect(() => {
        if (formInscripcion.abona === 'P') {
            handleFormInscripcion({
                ...formInscripcion,
                idpersonaentidad: ''
            })
        }
    }, [formInscripcion.abona]);

    // ------------- GET Aparatos

    const [fetchAparatosGET, fetchAparatosGETData] = AparatosServices.GET()

    useEffect(() => {

        fetchAparatosGET({
            params: {
                limit: 100,
                status: 'activos'
            }
        })
    }, []);

    return (
        <>

            <Form.Group className="mb-3 mb-sm-0 col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 col-xxl-6">
                <Form.Label className='fw-500'>{Lang('PERSONA')}</Form.Label>
                <InputGroup>
                    <InputText
                        name='persona'
                        value={filterPersona.nombre}
                        onChange={() => setFilterPersona({ id: '', nombre: '' })}
                    // validation={valuesValidationWizard1}
                    />
                    <InputGroup.Text id="basic-addon2" className='btn btn-secondary' onClick={handleShowModal_FiltroPersonas}>
                        <FontAwesomeIcon icon={faUser} className='' />
                    </InputGroup.Text>
                </InputGroup>
                {
                    !valuesValidationPersona.idpersona.isOk && <Form.Text className='text-danger d-block'>{Lang('VALIDACION_PERSONA_OBLIGATORIA')}</Form.Text>
                }
                {
                    idpedido &&
                    <small>
                        <u onClick={() => window.open(process.env.PUBLIC_URL + `/administracion/personas/${filterPersona.id}`)}
                            className='color-primary fw-500 pointer'>
                            {Lang('VER_FICHA_PERSONA')} <FontAwesomeIcon icon={faExternalLink} className='' />
                        </u>
                    </small>
                }
            </Form.Group>
            {
                !isGratuito &&
                <>
                    <Form.Group className="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-4 col-xxl-4">
                        <Form.Label className='fw-500 d-block'>{Lang('ABONA')}:</Form.Label>
                        <InputRadios
                            className=''
                            name='abona'
                            value={formInscripcion.abona}
                            values={[
                                { id: 'P', nombre: Lang('PERSONA') },
                                { id: 'E', nombre: Lang('ENTIDAD') },
                            ]}
                            onChange={handleInputInscripcion}
                        />
                    </Form.Group>

                    <div className="col-12"></div>

                    {
                        formInscripcion.abona === 'E' &&
                        <>

                            <Form.Group className="mt-3 col-12 col-sm-6 col-md-6 col-lg-6">

                                <InputSelect
                                    label={`${Lang('ENTIDAD')}:`}
                                    name='idpersonaentidad'
                                    value={formInscripcion.idpersonaentidad}
                                    onChange={handleInputInscripcion}
                                    // validation={valuesValidationCuenta}
                                    values={fetchPersonaEntidadGETData.data?.items?.map((item: any) => {
                                        return {
                                            id: item.id,
                                            nombre: item.nombreentidad
                                        }
                                    }) || []}
                                    validation={valuesValidationEntidad}
                                />
                            </Form.Group>
                            <div className="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-4 col-xxl-4">

                            </div>
                        </>
                    }

                    {
                        !idpedido &&
                        <Form.Group className="mt-3 mb-sm-0 col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 col-xxl-6">
                            <InputSelect
                                label={Lang('PARRAFO_SELECCIONE_APARATO_MEDIDA')}
                                name='idproducto'
                                value={formInscripcion.idproducto}
                                onChange={handleInputInscripcion}
                                values={fetchAparatosGETData.data?.items?.map((item: any) => {
                                    return {
                                        id: item.id,
                                        nombre: item.producto
                                    }
                                }) || []}
                            // validation={valuesValidationStep2}
                            />
                        </Form.Group>
                    }

                    <div className="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-4 col-xxl-4">

                    </div>
                </>
            }

            <FilterPersona
                showModal_FiltroPersonas={showModal_FiltroPersonas}
                handleCloseModal_FiltroPersonas={handleCloseModal_FiltroPersonas}
                setFilterPersona={setFilterPersona}
                params={
                    {
                        statuspersona: 'vigente'
                    }
                }
            />
        </>
    )
};
